
import { createNamespacedHelpers } from 'vuex'
import QuestionnairesCard from '~/components/pages/education/Questionnaires/QuestionnairesCard.vue'
import QuestionnairesCardSkeleton from '~/components/pages/education/Questionnaires/QuestionnairesCardSkeleton.vue'
import QuestionnairesTabsSkeleton from '~/components/pages/education/Questionnaires/QuestionnairesTabsSkeleton.vue'
const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'EducationQuestionnaires',

  components: {
    QuestionnairesCard,
    QuestionnairesCardSkeleton,
    QuestionnairesTabsSkeleton
  },

  data() {
    return {
      i18n: 'pages.education.questionnaires',
      bookmarkTabs: [],
      selectedTab: 'new'
    }
  },

  computed: {
    ...mapState(['questionnaires', 'isLoadingQuestionnaires']),

    filteredQuestionnaires() {
      const { selectedTab, questionnaires } = this

      if (questionnaires) {
        return Object.values(questionnaires)
          .sort((a, b) => (a.isNPS === b.isNPS ? 0 : a.isNPS ? -1 : 1))
          .filter(q =>
            selectedTab === 'new' ? !q.dateCompleted : q.dateCompleted
          )
      }

      return []
    }
  },

  created() {
    this.bookmarkTabs = this.$t(`${this.i18n}.tabs`)
  },

  methods: {
    selectTab(value) {
      this.selectedTab = value
    }
  }
}
